export const pickingSystem = {
    pickingWms: {
        id: '001',
        text: 'wms'
    },
    pickingTienda: {
        id: '002',
        text: 'Picking tienda'
    },
    pickinNa: {
        id: '003',
        text: 'NA'
    },
};

export const typeOfReason = {
  AUDIT: 'AUDIT'
}

export const zoneNames = {
  skuZone : 'Zona SKU'
}
